"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const LoadingService_1 = require("../Services/LoadingService");
const react_router_dom_1 = require("react-router-dom");
const react_bootstrap_1 = require("react-bootstrap");
const FormSelect_1 = __importDefault(require("../components/FormSelect"));
const ApiService_1 = require("../Services/ApiService");
const ToastService_1 = require("../Services/ToastService");
const utilities_1 = require("../assets/utilities/utilities");
const SearchUniformsPage = () => {
    const { id } = (0, react_router_dom_1.useParams)();
    const { stopLoading, startLoading } = (0, react_1.useContext)(LoadingService_1.LoadingContext);
    const [matricola, setMatricola] = react_1.default.useState();
    const [products, setProducts] = react_1.default.useState([]);
    const [categories, setCategories] = react_1.default.useState([]);
    const [selectedProduct, setSelectedProduct] = react_1.default.useState();
    const [selectedCategory, setSelectedCategory] = react_1.default.useState();
    const [isShowCategory, setIsShowCategory] = react_1.default.useState(false);
    const [isShowProducts, setIsShowProducts] = react_1.default.useState(false);
    const [isShowResults, setIsShowResults] = react_1.default.useState(false);
    const [isShowSizes, setIsShowSizes] = react_1.default.useState(false);
    const [isLoadingCollectionPoint, setIsLoadingCollectionPoint] = react_1.default.useState(false);
    const { showToast } = (0, react_1.useContext)(ToastService_1.ToastContext);
    const hasFetched = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(() => {
        if (hasFetched.current)
            return;
        hasFetched.current = true;
        startLoading();
        if (id) {
            fetchDataById(id);
        }
        else {
            fetchData();
        }
    }, []);
    const fetchDataById = async (idParam) => {
        try {
            const [fetchProductById, fetchCategories, fetchUser] = await Promise.all([
                (0, ApiService_1.fetchGetProductById)(idParam),
                (0, ApiService_1.fetchCategoriesImages)(),
                (0, ApiService_1.fetchUserData)()
            ]);
            setMatricola(fetchUser.matricola);
            setCategories(fetchCategories);
            const categoryRes = fetchCategories.find((c) => c.name == fetchProductById.category);
            setSelectedCategory(categoryRes);
            setFlow(fetchProductById);
            stopLoading();
        }
        catch (error) {
            stopLoading();
            console.error("Errore nel fetch:", error);
        }
    };
    const fetchData = async () => {
        try {
            const [fetchCategoryImages, fetchUser] = await Promise.all([
                (0, ApiService_1.fetchCategoriesImages)(),
                (0, ApiService_1.fetchUserData)()
            ]);
            setMatricola(fetchUser.matricola);
            setCategories(fetchCategoryImages);
            setIsShowCategory(true);
            stopLoading();
        }
        catch (error) {
            stopLoading();
            showToast('danger', 'Errore', 'Errore durante la chiamata alle API');
            console.error("Errore nel fetch:", error);
        }
    };
    const fetchCollectionPoints = async (prodSelect) => {
        var _a, _b;
        try {
            setIsLoadingCollectionPoint(true);
            startLoading();
            // Chiamata API per i punti di ritiro
            const response = await fetch(`/api/divise/get-collection-points?id=${prodSelect.id}`);
            const result = await response.json();
            if (((_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.length) === 0) {
                try {
                    const responseCheckNewSize = await fetch(`/api/divise/get-sizes-by-code?code=${prodSelect.code}&category=${prodSelect.category}`);
                    let resultCheckNewSize = await responseCheckNewSize.json();
                    if (((_b = resultCheckNewSize === null || resultCheckNewSize === void 0 ? void 0 : resultCheckNewSize.data) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                        window.scrollTo(0, 0);
                        setProducts(resultCheckNewSize.data);
                        setIsShowSizes(true);
                        setIsShowResults(false);
                        setIsShowCategory(false);
                        setIsShowProducts(false);
                        stopLoading();
                        return;
                    }
                }
                catch (error) {
                    console.error('Errore nel recupero delle taglie:', error);
                }
            }
            // Aggiorna lo stato con i punti di ritiro, se disponibili
            setCollectionPoints((result === null || result === void 0 ? void 0 : result.data) || []);
        }
        catch (error) {
            console.error('Errore nel recupero dei punti di ritiro:', error);
        }
        finally {
            setIsLoadingCollectionPoint(false);
            stopLoading();
        }
    };
    const navigate = (0, react_router_dom_1.useNavigate)();
    //categories are retrieved as an array of name and image (base64)
    //get the image from the base64 string
    const getImage = (image) => {
        return `data:image/png;base64,${image}`;
    };
    const [collectionPoints, setCollectionPoints] = react_1.default.useState();
    function setFlow(prod, prods = []) {
        if (prod) {
            setSelectedProduct(prod);
            stopLoading();
            fetchCollectionPoints(prod);
            setIsShowResults(true);
            setIsShowCategory(false);
            setIsShowProducts(false);
            setIsShowSizes(false);
        }
        else if (prods.length === 1) {
            setSelectedProduct(prods[0]);
            setIsShowSizes(false);
            setIsShowResults(true);
            setIsShowCategory(false);
            setIsShowProducts(false);
            stopLoading();
            fetchCollectionPoints(prods[0]);
        }
        else if (prods.length > 1) {
            window.scrollTo(0, 0);
            setProducts(prods);
            stopLoading();
            setIsShowSizes(false);
            setIsShowResults(false);
            setIsShowCategory(false);
            setIsShowProducts(true);
        }
    }
    async function selectCategory(category) {
        startLoading();
        setSelectedCategory(categories.find((c) => c.name == category));
        const data = { category };
        const response = await (0, ApiService_1.fetchProducts)(data);
        setFlow(undefined, response);
    }
    const handleReset = () => {
        window.scrollTo(0, 0);
        navigate('/ricerca-divisa');
        setIsShowCategory(true);
        setIsShowProducts(false);
        setIsShowResults(false);
        setIsShowSizes(false);
        setProducts([]);
        setSelectedProduct(undefined);
        setSelectedCategory(undefined);
        setCollectionPoints(undefined);
    };
    function goToMyEquipment() {
        window.scrollTo(0, 0);
        navigate('/la-mia-dotazione');
    }
    return (react_1.default.createElement("div", { className: "container p-0" },
        react_1.default.createElement("h1", { className: "title my-0" }, "Ricerca divisa"),
        react_1.default.createElement("p", { className: "mt-2" },
            "N. Maticola ",
            react_1.default.createElement("span", { className: "fw-bold" }, matricola)),
        react_1.default.createElement("p", null, "Trova la tua divisa in uno dei punti di ritiro."),
        react_1.default.createElement("hr", null),
        isShowCategory && react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("h3", { className: "fw-bold h5 mb-4" }, "Seleziona il prodotto che vuoi cercare"),
            react_1.default.createElement("div", { className: "d-flex gap-3" }, categories.map((category) => (react_1.default.createElement("div", { key: category.name, className: "box-shadow-9 br-20 mb-3", onClick: () => selectCategory(category.name) },
                react_1.default.createElement("img", { className: "overflow-hidden br-10", style: { minWidth: 70 }, width: 70, src: (0, utilities_1.returnImageCorrect)(category.name), alt: category.name })))))),
        isShowProducts && selectedCategory && react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("h3", { className: "fw-bold h5 mb-4" },
                "Ci sono pi\u00F9 prodotti per la tipologia ",
                selectedCategory.name,
                ", scegline uno."),
            react_1.default.createElement(FormSelect_1.default, { name: "product", label: "Prodotto", onChange: (e) => {
                    const product = products.find((product) => product.id == e.value);
                    setFlow(product);
                }, options: products.map((p) => ({ id: p.id, description: p.name + ' - ' + p.size })) })),
        isShowSizes && selectedCategory && selectedProduct && react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("h3", { className: "fw-bold h5 mb-4" }, "Non c'\u00E8 il prodotto per la taglia selezionata provane un'altra"),
            react_1.default.createElement("div", { className: "box-shadow-9 br-20 p-3 mt-3 mb-3" },
                react_1.default.createElement("div", { className: "d-flex align-items-center w-100" },
                    react_1.default.createElement("div", { className: "d-flex gap-2 align-items-center" },
                        react_1.default.createElement("div", null,
                            react_1.default.createElement("img", { className: "overflow-hidden br-10", width: 50, src: (0, utilities_1.returnImageCorrect)(selectedProduct.category), alt: selectedCategory.name })),
                        react_1.default.createElement("div", { className: "h6 fw-bold" }, selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.name)))),
            react_1.default.createElement(FormSelect_1.default, { name: "size", label: "Taglia", onChange: (e) => {
                    const product = products.find((product) => product.id == e.value);
                    setFlow(product);
                }, options: products.map((p) => ({ id: p.id, description: p.size })) })),
        isShowResults && selectedCategory && react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("h3", { className: "fw-bold h5 mb-4" }, "Ecco i risultati della tua ricerca"),
            react_1.default.createElement("h3", { className: "text-capitalize fw-bold h6 mt-3 mb-3" }, selectedCategory.name),
            react_1.default.createElement("div", { className: "box-shadow-9 br-20 p-3" },
                react_1.default.createElement("div", { className: "d-flex align-items-center w-100" },
                    react_1.default.createElement("div", { className: "d-flex gap-2 align-items-center" },
                        react_1.default.createElement("div", null, selectedProduct && react_1.default.createElement("img", { className: "overflow-hidden br-10", width: 50, src: (0, utilities_1.returnImageCorrect)(selectedProduct.category), alt: selectedCategory.name })),
                        react_1.default.createElement("div", { className: "h6 fw-bold" }, selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.name))),
                react_1.default.createElement("hr", null),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { className: "label fw-bold text-black" }, "Taglia"),
                    react_1.default.createElement("p", { className: "mb-0" }, selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.size))),
            react_1.default.createElement("hr", { className: "mt-5" }),
            react_1.default.createElement("h3", { className: "fw-bold h6 mt-5 mb-3" }, "Punti Ritiro"),
            collectionPoints && collectionPoints.map(collectionPoint => (react_1.default.createElement("div", { key: collectionPoint.id, className: "d-flex justify-content-between align-items-center box-shadow-9 br-20 p-3 mb-3" },
                react_1.default.createElement("div", null, collectionPoint.name),
                react_1.default.createElement("div", { className: "text-primary fw-bold fs-3" }, collectionPoint.quantity)))),
            isLoadingCollectionPoint && !collectionPoints && react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: "d-flex justify-content-between align-items-center br-20 p-3 mb-3 skeleton", style: { height: "74px" } }),
                react_1.default.createElement("div", { className: "d-flex justify-content-between align-items-center br-20 p-3 mb-3 skeleton", style: { height: "74px" } }),
                react_1.default.createElement("div", { className: "d-flex justify-content-between align-items-center br-20 p-3 mb-3 skeleton", style: { height: "74px" } })),
            react_1.default.createElement("div", { className: "d-flex gap-3 mt-5" },
                id && react_1.default.createElement(react_bootstrap_1.Button, { onClick: goToMyEquipment, className: "br-10 w-100", variant: "secondary" }, "Indietro"),
                react_1.default.createElement(react_bootstrap_1.Button, { variant: "primary", onClick: handleReset, className: "br-10 w-100" }, "Resetta")))));
};
exports.default = SearchUniformsPage;
